/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
export default {
  name: 'Notice',
  props: {
    noticeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Swiper: Swiper,
    SwiperItem: SwiperItem
  },
  data: function data() {
    return {};
  },
  computed: {
    height: function height() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return 1.76 * fontSize + 'px';
    }
  },
  created: function created() {}
};